import { OrganizationIntegrationRepository } from '@domain/organization-integration/repositories/organization-integration.repository';
import { OrganizationIntegrationRepositoryService } from '../repositories/organization-integration.service';

export const OrganizationIntegrationProvider = [
  {
    provide: OrganizationIntegrationRepository,
    useClass: OrganizationIntegrationRepositoryService,
  },
];
